import React, { useEffect } from "react";
import { all_routes } from "../router/all_routes";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";

const Footer = () => {
  const routes = all_routes;
  AOS.init();
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);
  const handleScroll = () => {
    AOS.refresh();
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
        {/* Footer */}
        <footer className="footer">
        {/* Footer Top */}	
        <div className="footer-top">
        {/* <div className="footer-top aos" data-aos="fade-down"> */}
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="row">
                  <div className="col-lg-8 col-md-8">
                    {/* Footer Widget */}
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title">About Company</h5>
                      <ul className="d-none">
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to={routes.aboutUs}>Our Company</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">Shop Toyota</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">Dreamsrentals USA</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">Dreamsrentals Worldwide</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">Dreamsrental Category</Link>
                        </li>										
                      </ul>
                      <p className="text-white">
                        Namo Cars offers reliable and affordable self-drive car rentals in Udaipur. Choose from a wide range of well-maintained cars for local travel, outstation trips, and hassle-free journeys across Rajasthan
                        </p>			
                      <div className="footer-social-widget">
                        <ul className="nav-social">
                          <li style={{ marginRight: "10px" }}>
                            <Link to="https://www.facebook.com/people/Namo-Cars/61576718792350/#" target="_BLANK">
                              <i className="fa-brands fa-facebook-f fa-facebook fi-icon" />
                            </Link>
                          </li>                          
                          <li style={{ marginRight: "10px" }}>
                            <Link to="https://www.instagram.com/namocars/" target="_BLANK">
                              <i className="fab fa-instagram fi-icon" />
                            </Link>
                          </li>
                          <li style={{ marginRight: "10px" }}>
                            <Link to="https://in.linkedin.com/in/namo-cars-a56b50370" target="_BLANK">
                              <i className="fab fa-linkedin fi-icon" />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* /Footer Widget */}
                  </div>
                  <div className="col-lg-4 d-none col-md-6">
                    {/* Footer Widget */}
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title">Vehicles Type</h5>
                      <ul>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">All  Vehicles</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">SUVs</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">Trucks</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">Cars</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link to="#">Crossovers</Link>
                        </li>								
                      </ul>
                    </div>
                    {/* /Footer Widget */}
                  </div>
                  <div className="col-lg-4 col-md-4">
                    {/* Footer Widget */}
                    <div className="footer-widget footer-menu">
                      <h5 className="footer-title">Quick links</h5>
                      <ul>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link className="text-white" to="/">Home</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link className="text-white" to="/listings/cars">Book Cars</Link>
                        </li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;
                          <Link className="text-white" to="/contact-us">Contact Us</Link>
                        </li>
                      </ul>
                    </div>
                    {/* /Footer Widget */}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-contact footer-widget">
                  <h5 className="footer-title">Contact Info</h5>
                  <div className="footer-contact-info">									
                    <div className="footer-address">											
                      <span>
                        <i className="fas fa-phone" /></span>
                      <div className="addr-info">
                        <Link className="text-white" to={`tel:${process.env.REACT_APP_CONTACT_MOBILE}`}>{process.env.REACT_APP_CONTACT_MOBILE}</Link>
                      </div>
                    </div>
                    <div className="footer-address">
                      <span><i className="fa fa-envelope" /></span>
                      <div className="addr-info">
                        <Link className="text-white" to={`mailto:${process.env.REACT_APP_CONTACT_EMAIL}`}>{process.env.REACT_APP_CONTACT_EMAIL}</Link>
                      </div>
                    </div>
                    <div className="d-none update-form">
                      <form action="#">
                        <span><i className="feather icon-mail" /></span> 
                        <input type="email" className="form-control" placeholder="Enter You Email Here" />
                        <button type="submit" className="btn btn-subscribe"><span><i className="feather icon-send" /></span></button>
                      </form>
                    </div>
                  </div>		
                </div>
              </div>
            </div>					
          </div>
        </div>
        {/* /Footer Top */}
        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="container">
            {/* Copyright */}
            <div className="copyright">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="copyright-text">
                    <p>&copy;2025 Namo Cars.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  {/* Copyright Menu */}
                  <div className="copyright-menu1">
                    <div className="vistors-details1 text-right">
                      <ul style={{ float: 'right' }} className="d-flex">
                        <li>
                          <Link className="text-white" to="/pages/terms-condition">Terms and Condition</Link>
                        </li>
                        <li>&nbsp;&nbsp;</li>
                        <li>
                          <Link className="text-white" to="/pages/privacy-policy">Privacy Policy</Link>
                        </li>			
                        {/* <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;<Link to="#"><ImageWithBasePath className="img-fluid" src="assets/img/icons/visa.svg" alt="Visa" /></Link></li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;<Link to="#"><ImageWithBasePath className="img-fluid" src="assets/img/icons/master.svg" alt="Master" /></Link></li>
                        <li><span><i className="fa-solid fa-circle-check"></i></span>&nbsp;<Link to="#"><ImageWithBasePath className="img-fluid" src="assets/img/icons/applegpay.svg" alt="applegpay" /></Link></li> */}
                      </ul>		
                      <div style={{ clear: 'both' }}></div>								   								
                    </div>
                  </div>
                  {/* /Copyright Menu */}
                </div>
              </div>
            </div>
            {/* /Copyright */}
          </div>
        </div>
        {/* /Footer Bottom */}			
      </footer>
      {/* /Footer */}
    </>
  );
};

export default Footer;
